// Tema do app: automático (segue o aparelho), claro ou escuro. A escolha é deste aparelho.
// O atributo data-app-theme fica sempre com o tema em uso ("light" ou "dark"), para o CSS ter um só seletor.
export type ThemePref = 'auto' | 'light' | 'dark';

const KEY = 'sublime-tema';
const media = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;

export function themePref(): ThemePref {
  try { const t = localStorage.getItem(KEY); return t === 'light' || t === 'dark' ? t : 'auto'; } catch { return 'auto'; }
}

function apply(pref: ThemePref) {
  const dark = pref === 'dark' || (pref === 'auto' && !!media?.matches);
  document.documentElement.setAttribute('data-app-theme', dark ? 'dark' : 'light');
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', dark ? '#161112' : '#F1E6DE');
}

export function setThemePref(pref: ThemePref) {
  try { if (pref === 'auto') localStorage.removeItem(KEY); else localStorage.setItem(KEY, pref); } catch { /* sem armazenamento */ }
  apply(pref);
}

export function initTheme() {
  apply(themePref());
  media?.addEventListener('change', () => apply(themePref()));
}
